<template lang="pug">
  // Button that triggers a MODAL to Create NEW Broadcast Campaign
  // @props dataLength: to assign unique id to new campaign
  div
    b-btn.pull-right.mr-1(type='button', variant='success', @click="largeModal = true")
      i.icon-plus
      |   Create New
    // MODAL create new campaign
    // TODO add date
    b-modal(lazy, title='Create new campaign', size='lg', v-model='largeModal', @ok='largeModal=false', ok-title='Launch')
      b-form(@submit='onSubmit')
        // TEXT Campaign Title
        b-form-group(id="broadcastInputGroup1" label="Campaign Title:" label-for="broadcastInput1")
          b-form-input(id="broadcastInput1" type="text" v-model="form.campaignTitle" required placeholder="Enter Campaign Title")
        // TEXTAREA Campaign Message
        b-form-group(id="broadcastInputGroup2" label="Campaign Message:" label-for="broadcastInput2")
          b-form-input(id="broadcastInput2" type="text" v-model="form.campaign" required placeholder="Enter Campaign Message")
        // SELECT Audience
        b-form-group(id="broadcastInputGroup3" label="Audience:" label-for="broadcastInput3")
          b-form-select(id="broadcastInput3" :options="campaignGroups" required v-model="form.campaignGroup")
        // SELECT Number
        b-form-group(id="broadcastInputGroupNumber" label="Number:" label-for="broadcastInputNumber")
          b-form-select(id="broadcastInputNumber" :options="campaignNumberGroups" required v-model="form.campaignNumberGroup")
        // DATE Start Date
        b-form-group(id="broadcastInputGroup4" label="Campaign Start Date:" label-for="broadcastInput4")
          b-form-input(id="broadcastInput4" type="date" v-model="form.start_date" required)
        // DATE End Date
        b-form-group(id="broadcastInputGroup5" label="Campaign End Date:" label-for="broadcastInput5")
          b-form-input(id="broadcastInput5" type="date" v-model="form.end_date" required)
        // CHECKBOX Email
        b-form-group(id="broadcastGroup6" label="<i class='fa fa-envelope-o'></i> Email" label-for="broadcastInput6" horizontal)
          b-form-checkbox(v-model="form.email" id="broadcastInput6")
        // CHECKBOX SMS
        b-form-group(id="broadcastGroup7" label="<i class='fa fa-mobile'></i> SMS" label-for="broadcastInput7" horizontal)
          b-form-checkbox(v-model="form.sms" id="broadcastInput7")
        // CHECKBOX Messenger
        b-form-group(id="broadcastGroup8" label="<i class='fa fa-facebook'></i> Messenger" label-for="broadcastInput8" horizontal)
          b-form-checkbox(v-model="form.messenger" id="broadcastInput8")
      div(slot='modal-footer')
        b-button.mr-1(type="submit" variant="primary" @click='onSubmit') Submit
        b-button(type="button" variant="outline-secondary" @click='largeModal = false') Cancel
</template>

<script>
import { db } from '@/firebase'

const campRef = db.ref('campaign')
const campGRef = db.ref('campaignGroups')
var d = new Date()
var today = d.getFullYear() + '-' + ((d.getMonth() < 9) ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-' + ((d.getDate() < 10) ? '0' + d.getDate() : d.getDate())

export default {
  name: 'broadcast-modal',
  data() {
    return {
      dataLength: 0,
      loading: true,
      largeModal: false,
      form: {
        sms: true,
        messenger: true,
        email: true,
        start_date: today,
        end_date: today,
        platform: 'webPopup',
        campaignGroup: '',
        campaignNumberGroup: '',
      },
      campaignGroups: null,
      campaignNumberGroups: null,
    }
  },
  mounted: function() {
    campRef.once('value').then((snapshot) => {
      this.dataLength = snapshot.numChildren()
    })
    var cGroups = []
    campGRef.once('value').then((snapshot) => {
      snapshot.forEach(function(item) {
        cGroups.push(item.key)
      })
      this.campaignGroups = cGroups
      this.form.campaignGroup = cGroups[0]
    })
    this.campaignNumberGroups = ['011-1700 0785']
    this.form.campaignNumberGroup = this.campaignNumberGroups[0]
  },
  methods: {
    onSubmit() {
      // MAP form field to campaign fields
      let form = {
        audience: this.form.campaignGroup,
        message: this.form.campaign,
        name: this.form.campaignTitle,
        messenger: this.form.messenger,
        email: this.form.email,
        sms: this.form.sms,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        sent: false,
        approval: 'pending',
        end: false,
      }
      console.log(form)
      this.dataLength += 1
      campRef.child(this.dataLength).set(form)
      this.largeModal = false
      this.$snotify.success(`Campaign ${form.name} is sent for approval!`)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/broadcastModal.vue?8e605de6